import React, { FC } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import type { IUser } from '../../../../model/user';
import type { IProject } from '../../../../model/project';
import type { ITool } from '../../../../model/tool';
import { observer } from 'mobx-react-lite';
import { isStateTreeNode, onSnapshot } from 'mobx-state-tree';
import { LabelHeader, usePrompt } from '@yakoffice/shared-components';
import styles from '../../../users/forms/user-form.module.sass';
import { UserProjectTabContents } from '../../../../components/user-project-tab-contents/user-project-tab-contents';
import { ProjectUserController } from '../../../../controllers/projectUserController';
import { IamRoles } from '../../../../components/iam-roles/iam-roles';

interface PropsType {
    project: IProject;
    tools: ITool[];
    user: IUser;
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const ProjectUserForm: FC<PropsType> = observer((props: PropsType) => {

    const [pageEdited, setPageEdited] = usePrompt('You have unsaved changes. Are you sure you want to leave?', false);

    // Flush sync to prevent batching which prevents immediate rerender
    const controller = ProjectUserController({
        setUserEditStatus: setPageEdited,
        projectId: props.project.id,
        updateCallbackTrigger: props.updateCallbackTrigger
    });

    if (isStateTreeNode(props.user))// So can pass in mock....
        onSnapshot(props.user, () => setPageEdited(true));

    const userEmailChange = (e: any) => {
        props.user.updateUserEmail(e.target.value);
    };

    return (
        <div className={styles.userForm}>
            <Row>
                <Col xl="6">
                    <Form.Group>
                        <Form.Label htmlFor="userEmail" className="">
                            <LabelHeader className="large"><i
                                className="fas fa-at" /> Email</LabelHeader>
                        </Form.Label>
                        <Form.Control type="email" id="userEmail" placeholder={props.user.email}
                                      defaultValue={props.user.email}
                                      disabled={!props.user.isNew}
                                      onChange={userEmailChange} />
                    </Form.Group>
                </Col>
                <Col xl="6">
                    <IamRoles projectId={props.project.id} user={props.user} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <UserProjectTabContents key={props.project.id} project={props.project} tools={props.tools}
                                            user={props.user} fromProjectUser={true} />
                </Col>
            </Row>
            <div className={styles.footer}>
                {pageEdited &&
                    <Button onClick={() => controller.saveUserForProject(props.project.id)} disabled={!pageEdited}
                            className={styles.saveUserButton}
                            data-testid="btnSave"><i className="fas fa-save" /> Save User</Button>}
                {!props.user.isNew &&
                    <Button variant="danger" className={styles.deleteUserButton}
                            onClick={() => controller.deleteUserFromProject(props.project.id)}><i
                        className="fas fa-trash" />Delete
                        User</Button>}

            </div>
        </div>
    );
});

export default ProjectUserForm;
